// extracted by mini-css-extract-plugin
module.exports = {"container":"MainLayout-module--container--1kQ9y","skipToMain":"MainLayout-module--skipToMain--3hs4n"};